import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Pagination, Button, Empty } from 'antd';
import { makeStyles } from '@material-ui/styles';
import NewPropertyCard from './new-property-card';
import { useTranslation } from 'react-i18next';
import theme from 'common/theme';
import { Reload } from 'common/components/svgs';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const useStyles = makeStyles(() => ({
  propertyLists: {
    minWidth: '800px',
    minHeight: '710px',
  },
  emptyPage: {
    backgroundColor: theme.colors.gray1,
    ...theme.flex.center,
    height: '700px!important',
  },
  reloadSvg: {
    width: '14px',
    fill: '#ffffff',
    marginRight: '5px',
    verticalAlign: 'middle',
    height: '100%',
  },
  resetBtn: {
    margin: 'auto',
    ...theme.typography.body3,
    ...theme.flex.crossCenter,
  },
}));

const PropertyLists = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { loading, dataSource, pagination, onChange, selectedList, onSelect, selectable } = props;
  const location = useLocation();
  const bookingJourneys = ['MANUAL', 'SEMI_AUTOMATIC', 'FULL_AUTOMATIC'];
  const locationSearch = useMemo(() => {
    const searchObj = queryString.parse(location.search);
    return searchObj;
  }, [location.search]);

  const isShowFilter = filters => {
    let showBtn = false;
    if (filters && typeof filters === 'string') {
      showBtn = bookingJourneys.includes(filters);
    }
    if (Array.isArray(filters)) {
      showBtn = filters.every(filter => bookingJourneys.includes(filter));
    }
    return showBtn;
  };

  return (
    <div className={classes.propertyLists}>
      <If condition={!!dataSource.length}>
        {dataSource?.map((item, index) => (
          <NewPropertyCard
            key={index}
            property={item}
            loading={loading}
            selected={selectedList.includes(item.id)}
            onSelect={onSelect}
            selectable={selectable}
          />
        ))}

        <div style={{ textAlign: 'right', marginTop: '16px' }}>
          <Pagination {...pagination} />
        </div>
      </If>
      <If condition={!dataSource.length}>
        <div className={classes.emptyPage}>
          <Empty
            imageStyle={{
              height: 100,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <If condition={isShowFilter(locationSearch?.bookingJourneys)}>
              <Button
                type="primary"
                className={classes.resetBtn}
                onClick={() => {
                  onChange({ bookingJourneys: [] });
                }}
              >
                <Reload className={classes.reloadSvg} />
                {t('cms:properties_reset_filter')}
              </Button>
            </If>
          </Empty>
        </div>
      </If>
    </div>
  );
};

PropertyLists.propTypes = {
  loading: PropTypes.bool.isRequired,
  dataSource: PropTypes.array.isRequired,
  pagination: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  selectedList: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectable: PropTypes.bool.isRequired,
};

export default PropertyLists;
